import { createSelector } from 'reselect';

const getReducer = (state) => state.exportModal;

export const emailSelector = createSelector(
  (state) => getReducer(state).email,
  (email) => email
);

export const selectionSelector = createSelector(
  (state) => getReducer(state).selection,
  (selection) => selection
);

export const typeOfExportSelector = createSelector(
  (state) => getReducer(state).typeOfExport,
  (typeOfExport) => typeOfExport
);

export const showSelector = createSelector(
  (state) => getReducer(state).show,
  (show) => show
);

export const isLoadingStateSelector = createSelector(
  (state) => getReducer(state).isLoadingState,
  (isLoadingState) => isLoadingState
);

export const isExportStateSelector = createSelector(
  (state) => getReducer(state).isExportState,
  (isExportState) => isExportState
);

export const exportResultSelector = createSelector(
  (state) => getReducer(state).exportResult,
  (exportResult) => exportResult
);
